import permissions from 'constants/permissions'

const SOLICITATION_TICKET_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.SOLICITATION_TICKET.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.SOLICITATION_TICKET.MANAGE,
  },
]

export default SOLICITATION_TICKET_LIST
